export const UserRole = {
  Admin: 'SUPER',
  Editor: 'USER',
};
export const CLIENT_ID_GOOGLE = '159632966624-fcl92oe5q2dukshr7ep06k87mmcs1pqq.apps.googleusercontent.com';
export const APP_ID_FACEBOOK = '1397712557481530';
export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;
export const addCart = '/detailCart';
export const thankYouForPay = '/congrats';
export const checkout = '/checkout';
export const myorders = '/myorders';

// export const currentUser = {
//     id: 1,
//     title: 'Sarah Kortney',
//     img: '/assets/img/profiles/l-1.jpg',
//     date: 'Last seen today 15:24',
//     role: UserRole.Admin,
//   };
export const isAuthGuardActive = true;


export const urlBase = 'https://api-rest.egoi.com.co/api/v1';
export const urlBase2 = 'https://api-rest.egoi.com.co/api/v2';

export const SITE_URL = 'https://www.egoi.com.co';
export const SITE_NAME = 'Egoi';
export const DEFAULT_SEO_DESCRIPTION = 'Egoi Ecommerce - Comercio electrónico en Colombia. Encuentra tecnología, hogar y más con los mejores precios y envíos a todo el país.';
export const DEFAULT_SEO_IMAGE = `${SITE_URL}/logo512.png`;
// WhatsApp de ventas (el mismo publicado en la página de contacto), en formato internacional.
export const WHATSAPP_SALES_NUMBER = '573054314064';
